import { render, staticRenderFns } from "./municipalities.html?vue&type=template&id=6ad6fc22&"
import script from "./municipalities.js?vue&type=script&lang=js&"
export * from "./municipalities.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports